import bugsnagClient from '../bugsnag'

const PasswordValidator = require('password-validator')

const funcs = {
  isInLiliApp: function () {
    return navigator.userAgent.match(/Lili/i)
  },
  deviceType: function () {
    if (/Android/i.test(navigator.userAgent)) {
      return 'ANDROID'
    } else if (/iPad|iPhone|iPod/.test(navigator.platform)) {
      return 'IOS'
    } else {
      return 'OTHER'
    }
  },
  isMobile: function () {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      return true
    } else {
      return false
    }
  },
  isJson: function isJson(str) {
    try {
      JSON.parse(str)
    } catch (e) {
      return false
    }
    return true
  },
  setFieldClass: function () {
    let activeElement = document.activeElement
    activeElement.parentElement.parentElement.parentElement.classList.remove(
      'field'
    )
    activeElement.parentElement.parentElement.parentElement.classList.add(
      'selectedField'
    )
  },
  removeFieldClass: function (activeElement) {
    if (
      activeElement &&
      activeElement.currentTarget &&
      activeElement.currentTarget.parentElement &&
      activeElement.currentTarget.parentElement.parentElement &&
      activeElement.currentTarget.parentElement.parentElement.parentElement
    ) {
      activeElement.currentTarget.parentElement.parentElement.parentElement.classList.remove(
        'selectedField'
      )
      activeElement.currentTarget.parentElement.parentElement.parentElement.classList.add(
        'field'
      )
    }
  },
  // https://tarunbatra.com/password-validator/4.1.1/
  getPasswordComplexity: function () {
    let schema = new PasswordValidator()
    schema.is().min(8) // Minimum length 8
    // .is().max(20)                                   // Maximum length 100
    // .has().uppercase()                              // Must have uppercase letters
    // .has().lowercase()                              // Must have lowercase letters
    // .has().symbols()
    // .has().digits()                                 // Must have digits
    // .has().not().spaces()                           // Should not have spaces
    return schema
  },
  validatePasswordComplexity: function (data) {
    // noinspection JSCheckFunctionSignatures
    return funcs.getPasswordComplexity().validate(data)
  },
  disableNameCharacters: function (event) {
    return funcs.disableGeneric(event, '^[a-zA-Z0-9\\- ]+$')
  },

  disableEmailCharacters: function (event) {
    return funcs.disableGeneric(event, '^[a-zA-Z0-9@\\.\\-_]+$')
  },

  disableNumberCharacters: function (event) {
    return funcs.disableGeneric(event, '^[0-9]+$')
  },

  disableAddressCharacters: function (event) {
    return funcs.disableGeneric(event, '^[a-zA-Z0-9, ]+$')
  },

  disableGeneric: function (event, regString) {
    const regex = new RegExp(regString)
    const key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    )
    if (!regex.test(key)) {
      event.preventDefault()
      return false
    }
  },

  checkNameCharacters: function (value) {
    return funcs.checkGeneric(value, '^[a-zA-Z\\- ]+$')
  },

  checkGeneric: function (value, regString) {
    const regex = new RegExp(regString)
    return regex.test(value)
  },

  internalMove: function (
    self,
    url,
    bodyObject,
    targetPage,
    errorMap,
    defaultErrorField
  ) {
    self.loading = true
    self.$axios
      .post(url, bodyObject, {
        headers: {
          Authorization: 'Bearer ' + self.$customerDetails.accessToken,
        },
        timeout: 180000,
      })
      .then((response) => {
        self.loading = false
        self.$router.push(targetPage)
        self.$lastResponse = response
      })
      .catch((error) => {
        let response = error.response
        if (!response) {
          response = error
        }
        funcs.printLiliHeaders(url, response)
        let businessLogicError = false
        // self.errors.clear()
        if (response.data && response.data.errors && response.data.errors[0]) {
          let message = response.data.errors[0].message
          // eslint-disable-next-line no-prototype-builtins
          if (!errorMap[message] && !errorMap.hasOwnProperty(message)) {
            message = response.data.errors[0].codeName
          }
          // eslint-disable-next-line no-prototype-builtins
          if (errorMap[message] || errorMap.hasOwnProperty(message)) {
            businessLogicError = true
            if (errorMap[message].redirect) {
              if (errorMap[message].redirect === '/index.html') {
                self.$store.state.backDialog = false
                self.$store.state.backDialogConfirmed = true
                self.$customerDetails = funcs.initCustomerDetails(
                  self.$customerDetails
                )
                self.$router.push('/index.html')
              } else {
                self.$router.push(errorMap[message].redirect)
              }
            } else {
              self.$refs.obs.setErrors({
                [errorMap[message].field]: self.$i18n.t(
                  'validation.custom.' +
                    errorMap[message].field +
                    '.' +
                    errorMap[message].message
                ),
              })
            }
          }
        } else if (response.status === 401) {
          businessLogicError = true
          self.$mam.error('Access token timeout')
          // bugsnagClient.notify(new Error('Access token timeout'))
          self.$store.state.timeout = true
          // self.$router.push('/ob/intro')
          // self.$refs.obs.setErrors({field: 'firstName', msg: self.$i18n.t('errors.tokenTimeout')})
        }
        if (!businessLogicError) {
          self.$refs.obs.setErrors({
            [defaultErrorField]: self.$i18n.t('errors.oops'),
          })
          bugsnagClient.notify(new Error(JSON.stringify(response)))
          self.$mam.error(response)
        }
        self.loading = false
      })
  },

  initCustomerDetails: function (customerDetails) {
    let oldAdSource = customerDetails.adSource
    let oldIsAccountTypeFlow = customerDetails.isAccountTypeFlow
    let newCustomerDetails = {}
    newCustomerDetails.adSource = oldAdSource
    newCustomerDetails.pro = false
    newCustomerDetails.isAccountTypeFlow = oldIsAccountTypeFlow
    return newCustomerDetails
  },

  printLiliHeaders: function (url, response) {
    if (response && response.headers && response.headers.lililogid) {
      console.error(
        'URL call ' + url + ' server request # is ' + response.headers.lililogid
      )
    }
  },

  callAndMoveForward: function (
    self,
    url,
    bodyObject,
    targetPage,
    errorMap,
    defaultErrorField
  ) {
    // Refactor Task: move whole flow to HttpService
    const prefixUrl =
      process.env.NODE_ENV === 'development' ? 'https://integ.lili.co' : ''
    funcs.internalMove(
      self,
      prefixUrl + url,
      bodyObject,
      targetPage,
      errorMap,
      defaultErrorField
    )
  },

  getRecaptchSiteKey: function () {
    return process.env.VUE_APP_CAPTCHA
  },

  validatePassword: function (pw, options) {
    // default options (allows any password)
    var o = {
      lower: 0,
      upper: 0,
      alpha: 0 /* lower + upper */,
      numeric: 0,
      special: 0,
      length: [0, Infinity],
      custom: [
        /* regexes and/or functions */
      ],
      badWords: [],
      badSequenceLength: 0,
      noQwertySequences: false,
      noSequential: false,
      noSequentialLength: 0,
    }

    for (var property in options) {
      o[property] = options[property]
    }

    let re = {
      lower: /[a-z]/g,
      upper: /[A-Z]/g,
      alpha: /[A-Z]/gi,
      numeric: /[0-9]/g,
      special: /[\W_]/g,
    }
    let rule
    let i
    // enforce min/max length
    if (pw.length < o.length[0] || pw.length > o.length[1]) {
      return false
    }

    // enforce lower/upper/alpha/numeric/special rules
    for (rule in re) {
      if ((pw.match(re[rule]) || []).length < o[rule]) {
        return false
      }
    }

    // enforce word ban (case insensitive)
    for (i = 0; i < o.badWords.length; i++) {
      if (pw.toLowerCase().indexOf(o.badWords[i].toLowerCase()) > -1) {
        return false
      }
    }

    // enforce the no sequential, identical characters rule
    if (o.noSequential && /([\S\s])\1/.test(pw)) {
      return false
    }

    if (o.noSequentialLength) {
      let counter = 1
      let lastChar = ''
      for (i = 0; i < pw.length; i++) {
        if (pw[i] === lastChar) {
          ++counter
        } else {
          lastChar = pw[i]
          counter = 1
        }
        if (counter >= o.noSequentialLength) {
          return false
        }
      }
    }

    // enforce alphanumeric/qwerty sequence ban rules
    if (o.badSequenceLength) {
      let lower = 'abcdefghijklmnopqrstuvwxyz'
      let upper = lower.toUpperCase()
      let numbers = '0123456789'
      let qwerty = 'qwertyuiopasdfghjklzxcvbnm'
      let start = o.badSequenceLength - 1
      let seq = '_' + pw.slice(0, start)
      for (i = start; i < pw.length; i++) {
        seq = seq.slice(1) + pw.charAt(i)
        if (
          lower.indexOf(seq) > -1 ||
          upper.indexOf(seq) > -1 ||
          numbers.indexOf(seq) > -1 ||
          (o.noQwertySequences && qwerty.indexOf(seq) > -1)
        ) {
          return false
        }
      }
    }

    // enforce custom regex/function rules
    for (i = 0; i < o.custom.length; i++) {
      rule = o.custom[i]
      if (rule instanceof RegExp) {
        if (!rule.test(pw)) {
          return false
        }
      } else if (rule instanceof Function) {
        if (!rule(pw)) {
          return false
        }
      }
    }

    return true
  },
  states: function () {
    return [
      { abbr: 'AK', state: 'AK' },
      { abbr: 'AL', state: 'AL' },
      { abbr: 'AR', state: 'AR' },
      { abbr: 'AZ', state: 'AZ' },
      { abbr: 'CA', state: 'CA' },
      { abbr: 'CO', state: 'CO' },
      { abbr: 'CT', state: 'CT' },
      { abbr: 'DC', state: 'DC' },
      { abbr: 'DE', state: 'DE' },
      { abbr: 'FL', state: 'FL' },
      { abbr: 'GA', state: 'GA' },
      { abbr: 'HI', state: 'HI' },
      { abbr: 'IA', state: 'IA' },
      { abbr: 'ID', state: 'ID' },
      { abbr: 'IL', state: 'IL' },
      { abbr: 'IN', state: 'IN' },
      { abbr: 'KS', state: 'KS' },
      { abbr: 'KY', state: 'KY' },
      { abbr: 'LA', state: 'LA' },
      { abbr: 'MA', state: 'MA' },
      { abbr: 'MD', state: 'MD' },
      { abbr: 'ME', state: 'ME' },
      { abbr: 'MI', state: 'MI' },
      { abbr: 'MN', state: 'MN' },
      { abbr: 'MO', state: 'MO' },
      { abbr: 'MS', state: 'MS' },
      { abbr: 'MT', state: 'MT' },
      { abbr: 'NC', state: 'NC' },
      { abbr: 'NE', state: 'NE' },
      { abbr: 'NH', state: 'NH' },
      { abbr: 'NJ', state: 'NJ' },
      { abbr: 'NM', state: 'NM' },
      { abbr: 'NV', state: 'NV' },
      { abbr: 'NY', state: 'NY' },
      { abbr: 'ND', state: 'ND' },
      { abbr: 'OH', state: 'OH' },
      { abbr: 'OK', state: 'OK' },
      { abbr: 'OR', state: 'OR' },
      { abbr: 'PA', state: 'PA' },
      { abbr: 'RI', state: 'RI' },
      { abbr: 'SC', state: 'SC' },
      { abbr: 'SD', state: 'SD' },
      { abbr: 'TN', state: 'TN' },
      { abbr: 'TX', state: 'TX' },
      { abbr: 'UT', state: 'UT' },
      { abbr: 'VT', state: 'VT' },
      { abbr: 'VA', state: 'VA' },
      { abbr: 'WA', state: 'WA' },
      { abbr: 'WI', state: 'WI' },
      { abbr: 'WV', state: 'WV' },
      { abbr: 'WY', state: 'WY' },
    ]
  },
  stateOptions: function () {
    return [
      { id: 'AK', title: 'AK' },
      { id: 'AL', title: 'AL' },
      { id: 'AR', title: 'AR' },
      { id: 'AZ', title: 'AZ' },
      { id: 'CA', title: 'CA' },
      { id: 'CO', title: 'CO' },
      { id: 'CT', title: 'CT' },
      { id: 'DC', title: 'DC' },
      { id: 'DE', title: 'DE' },
      { id: 'FL', title: 'FL' },
      { id: 'GA', title: 'GA' },
      { id: 'HI', title: 'HI' },
      { id: 'IA', title: 'IA' },
      { id: 'ID', title: 'ID' },
      { id: 'IL', title: 'IL' },
      { id: 'IN', title: 'IN' },
      { id: 'KS', title: 'KS' },
      { id: 'KY', title: 'KY' },
      { id: 'LA', title: 'LA' },
      { id: 'MA', title: 'MA' },
      { id: 'MD', title: 'MD' },
      { id: 'ME', title: 'ME' },
      { id: 'MI', title: 'MI' },
      { id: 'MN', title: 'MN' },
      { id: 'MO', title: 'MO' },
      { id: 'MS', title: 'MS' },
      { id: 'MT', title: 'MT' },
      { id: 'NC', title: 'NC' },
      { id: 'NE', title: 'NE' },
      { id: 'NH', title: 'NH' },
      { id: 'NJ', title: 'NJ' },
      { id: 'NM', title: 'NM' },
      { id: 'NV', title: 'NV' },
      { id: 'NY', title: 'NY' },
      { id: 'ND', title: 'ND' },
      { id: 'OH', title: 'OH' },
      { id: 'OK', title: 'OK' },
      { id: 'OR', title: 'OR' },
      { id: 'PA', title: 'PA' },
      { id: 'RI', title: 'RI' },
      { id: 'SC', title: 'SC' },
      { id: 'SD', title: 'SD' },
      { id: 'TN', title: 'TN' },
      { id: 'TX', title: 'TX' },
      { id: 'UT', title: 'UT' },
      { id: 'VT', title: 'VT' },
      { id: 'VA', title: 'VA' },
      { id: 'WA', title: 'WA' },
      { id: 'WI', title: 'WI' },
      { id: 'WV', title: 'WV' },
      { id: 'WY', title: 'WY' },
    ]
  },
  isIncomeTypeLLCPlus: function (incomeType) {
    return ['MMLLC', 'C_CORP', 'S_CORP', 'GENERAL_PARTNERSHIP', 'LLP'].includes(
      incomeType
    )
  },
  doesBusinessHaveUBOs: function (businessOwnersArr) {
    return businessOwnersArr && businessOwnersArr.length > 0
  },
}

export default funcs



// WEBPACK FOOTER //
// ./src/utils/shared.js